import {createStyles} from '@mantine/core';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

const useStyles = createStyles((theme) => ({
  footer: {
    borderTop: `1px solid ${theme.colors.gray[2]}`,
  },
  sticky: {
    position: 'sticky',
    bottom: 0,
    margin: '16px -16px -16px',
    padding: '16px 20px !important',
    backgroundColor: 'white',
  },
}));

export interface ModalFooterProps {
  /* Used for any arbitrary content to display in the footer */
  children?: React.ReactNode;
  /* Custom styles to apply to the footer container */
  className?: string;
  /* Whether to apply the default modal styling to make the footer sticky */
  sticky?: boolean;
}

export default function ModalFooter({children, className, sticky = true}: ModalFooterProps): JSX.Element {
  const {classes, cx} = useStyles();
  return (
    <div
      className={cx(className, classes.footer, sticky && classes.sticky)}
      {...getTestProps({component: 'Modal', element: 'footer'})}
    >
      {children}
    </div>
  );
}
